// extracted by mini-css-extract-plugin
export default {"tac":"copyright-policy_tac__BankW","link":"copyright-policy_link__BRulK","copyright":"copyright-policy_copyright__61Dxj"};